import Index from './index.vue'
import Potential from './potential.vue'

const basePath = '/v-admin/potential'

export default {
  name: 'potentialApplicationList',
  path: `${basePath}`,
  component: Index,
  meta: {
    isInclude: true,
    permission: 'PREMIUM_SOFT_USER',
    titleI18nKey: 'admin.talent.pool.potential'
  },
  children: [
    {
      name: 'talentPotentialApplicationList',
      path: '/v-admin/talent-pool/:talentFilterGroupId/potential/list',
      component: Potential,
      meta: {
        isInclude: true,
        permission: 'PREMIUM_SOFT_USER',
        titleI18nKey: 'admin.talent.pool.potential'
      }
    },
    {
      name: 'jobPotentialList',
      path: '/v-admin/job/:jobId/potential/list',
      component: Potential,
      meta: {
        isInclude: true,
        permission: 'PREMIUM_SOFT_USER',
        titleI18nKey: 'admin.application.applicantList.title.potential'
      }
    }
  ]
}
